import { Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ToolsService } from '../services/tools/tools.service';
import { ToolModel } from '../../shared/entities/tool.model';

@Injectable()
export class ToolModelRepository {
  constructor(private ToolModelService: ToolsService) {}

  public createNewToolModel(tool?: ToolModel): Observable<any> {
    return this.ToolModelService.postToolModel(tool!).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((err) => {
        return observableOf(err);
      }),
    );
  }

  public getAdminToolById(id?: string): Observable<ToolModel> {
    return this.ToolModelService.getToolModelById(id!).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((err) => {
        return observableOf(err);
      }),
    );
  }

  public updateAdminToolById(id?: string, tool?: ToolModel): Observable<any> {
    return this.ToolModelService.updateToolModelById(id!, tool!).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((err) => {
        return observableOf(err);
      }),
    );
  }

  public getAdminTools(query: any = {}): Observable<any> {
    return this.ToolModelService.getToolsModels(query).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((err) => {
        return observableOf(err);
      }),
    );
  }

  public deleteAdminTools(id: string): Observable<any> {
    return this.ToolModelService.deleteToolModelById(id).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((err) => {
        return observableOf(err);
      }),
    );
  }
}
